import { Button, Counter } from "@maxhub/max-ui"

export const CounterInButtonExample = {
  title: "Counter - Counter in Button",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [],

  Preview() {
    return (
      <Button indicator={<Counter value={32}/>}>
        Messages
      </Button>
    )
  },

  getCode() {
    return `<Button indicator={<Counter value={32} />}>
  Messages
</Button>`
  },
}